const translations = {
    title: 'Work Order'
};

export default translations;
